<template>
    <div id="app">
        <ErrorMessage v-if="error"/>
        <Spinner v-if="loading"/>
        <template v-if="!error">
            <div class="main-container">
                <Loader v-if="!initialLoadCompleted"/>
                <template v-if="initialLoadCompleted">

                    <div class="logo-bar">
                        <Logo/>
                    </div>

                    <div class="search-bar">
                        <h2
                            v-if="report.name"
                            class="report-name">
                            {{ report.name }}
                        </h2>

                        <div class="search-bar-buttons">
                            <RefreshButton/>
                        </div>
                    </div>
                    <div
                        v-if="report.timeRangeLabel"
                        class="report-time-range">
                        <p>{{ report.timeRangeLabel }}</p>
                    </div>
                    <div class="toolbar">
                        <Pager
                            :page="page"
                            :total-pages="totalPages"
                            :total-results="totalResults"/>
                        <div class="right-side">
                            <RowLimitter :limit="limit"/>
                            <ColumnSelector :columns="columns"/>
                        </div>
                    </div>
                    <div class="table">
                        <Table
                            :columns="columns"
                            :report="report"/>
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
import { Loader, Table, ErrorMessage, RowLimitter, Pager, RefreshButton, ColumnSelector, Logo, Spinner, InlineButton } from './components';
import EEAService from './services/EEAService';

import { mapState } from 'vuex';

import HelpIcon from 'voluum-frontend-icons/help.svg';
import VoluumIcon from 'voluum-frontend-icons/voluum.svg';

export default {
    name: 'App',
    inherit: true,

    components: {
        Loader,
        ErrorMessage,
        Table,
        RowLimitter,
        Pager,
        RefreshButton,
        ColumnSelector,
        Logo,
        Spinner,
        InlineButton
    },

    data: function () {
        return {
            helpIcon: HelpIcon,
            voluumIcon: VoluumIcon
        };
    },

    computed: mapState({
        page: 'page',
        report: 'report',
        error: 'error',
        initialLoadCompleted: 'initialLoadCompleted',
        limit: 'limit',
        sort: 'sort',
        columns: 'columns',
        loading: 'loading',
        totalPages: (state) => {
            return Math.ceil(state.report.totalRows / state.limit);
        },
        totalResults: (state) => state.report.totalRows
    }),

    created: function () {
        this.$store.dispatch('loadReport');
    },

    mounted: function () {
        if (window.dataLayer !== undefined) {
            EEAService.getEEAStatus().then(
                (response) => {
                    window.dataLayer.push(response);
                }
            );
        }
    }
};
</script>

<style lang="less">

    @import "./styles/globals.less";
    @import "./styles/colors.less";

    .toolbar,
    .search-bar,
    .table,
    .logo-bar,
    .right-side {
        display: flex;
    }

    .toolbar,
    .search-bar,
    .logo-bar,
    .table,
    .report-time-range,
    .footer {
        padding: @padding;
    }

    .table, .toolbar {
        padding-top: 0;
    }

    .toolbar,
    .search-bar {
        justify-content: space-between;
    }

    .search-bar {
        align-items: center;
    }

    .report-time-range {
        padding-top: 0;
        margin-bottom: @padding;
        text-align: left;
    }

    .report-time-range p {
        margin: 0;
        font-size: 16px;
    }

    .report-name,
    .search-bar-buttons,
    .table {
        flex: 1;
    }

    .report-name {
        text-align: left;
    }

    .search-bar-buttons {
        text-align: right;
    }

    .logo-bar {
        justify-content: space-between;
        align-items: center;
        display: flex;

        img {
            width: 125px;
        }

        .buttons {
            align-self: center;
            display: flex;
        }
    }

    .powered-by-button {
        padding-left: 16px;
        margin-left: 16px;
        border-left: 1px solid @color-grey;
    }

    .report-name {
        margin: 0;
    }

    .footer {
        text-align: right;
        a {
            color: #363636;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue